import { TypographyVariantsOptions } from '@mui/material/styles'

import colors from '@/assets/scss/_themes-vars.module.scss'

const typography: TypographyVariantsOptions = {
  htmlFontSize: 16,
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    color: colors.gray900
  },
  h2: {
    color: colors.gray900,
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '30px'
  },
  h3: {
    color: colors.gray900
  },
  h4: {
    color: colors.gray900
  },
  h5: {
    color: colors.gray900
  },
  h6: {
    color: colors.gray900
  },
  // subtitle1: {},
  // subtitle2: {},
  // body1: {},
  // body2: {},
  // caption: {},
  // overline: {}
}

export default typography